module.exports = __webpack_public_path__ + "img/armin-novacek.fe3145ae.jpg";